import { Label } from "@/components/ui/label";
import { Input } from "../../ui/input";
import { ChangeEvent } from "react";

interface InputWithLabelProps {
    label?: string;
    placeholder?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    value?: string | number;
    min?: string | number;
    max?: string | number;
    disable?: boolean;
    readOnly?: boolean;
    className?: string;
}

const InputWithLabel= ({ label, max, min, onChange, placeholder, type, value, disable = false, readOnly = false, className}: InputWithLabelProps) => {

    return (
        <div className="grid w-full max-w-sm items-center gap-1.5 mt-[10px] mb-[10px]">
            <Label className="text-colorPrimary font-normal" htmlFor={label}>{label}</Label>
            <Input
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                min={min}
                max={max}
                disabled={disable}
                className={className}
                readOnly={readOnly}
            />
        </div>
    );
}

export { InputWithLabel };